var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifiaction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7349_204110)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.6484 17.777C9.6484 17.771 9.6454 17.767 9.6454 17.761H14.3504C14.3504 17.767 14.3474 17.771 14.3474 17.777L15.8444 17.761H17.4704C18.4284 17.761 19.3064 17.278 19.8204 16.469C20.3334 15.661 20.3954 14.661 19.9884 13.794L19.5224 12.804C19.2234 12.17 19.0654 11.463 19.0654 10.761L19.0644 9.44295C19.0644 5.54695 15.8944 2.37695 11.9984 2.37695C8.1024 2.37695 4.9324 5.54695 4.9324 9.44295L4.9314 10.761C4.9314 11.462 4.7734 12.168 4.4744 12.804L4.0094 13.794C3.6014 14.66 3.6634 15.661 4.1764 16.469C4.6894 17.278 5.5684 17.761 6.5264 17.761H8.1514C8.1514 17.767 8.1484 17.771 8.1484 17.777H9.6484Z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64844 17.7777L8.15144 17.7617C8.15144 17.7647 8.15069 17.7672 8.14994 17.7697C8.14919 17.7722 8.14844 17.7747 8.14844 17.7777C8.14844 19.9007 9.87544 21.6277 11.9974 21.6277C14.1204 21.6277 15.8444 19.885 15.8444 17.762L14.3504 17.7617C14.3504 17.7647 14.3497 17.7672 14.3489 17.7697C14.3482 17.7722 14.3474 17.7747 14.3474 17.7777C14.3474 19.0727 13.2934 20.1277 11.9974 20.1277C10.7024 20.1277 9.64844 19.0727 9.64844 17.7777Z",
    fill: "#484848"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7349_204110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifiaction);
export default __webpack_public_path__ + "static/media/notifiaction.37cec8975f1fd307a73461c90f16c2f3.svg";
export { ForwardRef as ReactComponent };